/**
* @name APP UPlanner
* @autor jorge.herrero@dbaccess.com
* @description
* # name controller --> reportModalCtrl
* # As Controller --> reportModal
* brief comment controller for show dialog close Assistence

*/

export default class reportModalCtrl{

	constructor($scope,$resource,$mdDialog,items,$state){
		var vm = this;
        vm.close = close;
        vm.load = load;
        vm.save = save
        vm.edit = edit
        vm.delet = delet
        vm.see = see

      	//Methods
        function save(){
        	let data = {action: "save", value:vm.nameReport}

        	if(data.value)
      			$mdDialog.hide(data);
        }

        function close(){
      			$mdDialog.hide();
        }

        function load(){
            vm.data = items
        }

        function edit(report){
        	let data = {action: "edit", value:report}
        	$mdDialog.hide(data);
        }

        function delet(report){
        	let data = {action: "delet", value:report}
        	$mdDialog.hide(data);
        }

        function see(report){
        	let data = {action: "see", value:report}
        	$mdDialog.hide(data);
        }

        load()
    }
}

reportModalCtrl.$inject = ['$scope','$resource','$mdDialog','items','$state'];




// WEBPACK FOOTER //
// ./src/app/u-faculty/report/modals/reportModalCtrl.js